/** Shown once on admin login after API session expiry redirect. */
export const ADMIN_SESSION_EXPIRED_TOAST_MESSAGE = 'Your session has expired. Please log in again.';

export const ADMIN_SESSION_EXPIRED_FLASH_KEY = 'spence:admin:session-expired-toast';

export function persistAdminSessionExpiredFlash(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage?.setItem(ADMIN_SESSION_EXPIRED_FLASH_KEY, '1');
  } catch {
    // Ignore quota / private mode — redirect still proceeds.
  }
}

/** Read-and-clear so the toast shows at most once after redirect. */
export function consumeAdminSessionExpiredFlash(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const stored = window.sessionStorage?.getItem(ADMIN_SESSION_EXPIRED_FLASH_KEY);
    if (stored !== '1') {
      return false;
    }

    window.sessionStorage?.removeItem(ADMIN_SESSION_EXPIRED_FLASH_KEY);
    return true;
  } catch {
    return false;
  }
}
